import { z } from 'zod';

export const CodeEnforcementViolationScalarFieldEnumSchema = z.enum(['violationId','cityId','caseId','violationTypeId','violationGrouping','dateViolationDue','violationStatus','dateViolationClosed','details','violationUnit','violationRoom','externalId','rowTimestamp']);

export default CodeEnforcementViolationScalarFieldEnumSchema;
